<p-dropdown
    class="w-100"
    styleClass="w-100"
    inputStyleClass="w-100"
    appendTo="body"
    dataKey="genderId"
    optionLabel="name"
    [placeholder]="placeholder"
    [showClear]="showClear"
    [options]="genders"
    [(ngModel)]="selected"
    (ngModelChange)="onSelectionChange()">
</p-dropdown>
